<template>
  <div>
    <div class="categories-container">
      <h4 class="categories-title">Categories</h4>

      <b-card-group deck class="categories-deck">
        <b-card
          title="Show All"
          :img-src="liveqaShowAllImg"
          img-alt="Show All"
          img-top
          class="text-center"
          @click="$emit('navigate', 'LiveQAShowAllCards'); categorySelected('ShowAll');"
        >
        </b-card>
        
        <b-card
          title="Live Q&A Sessions"
          :img-src="extraImg"
          img-alt="Live Q&A Sessions"
          img-top
          class="text-center"
          @click="$emit('navigate', 'LiveQAShowAllCards'); categorySelected('MasterApp');"
        >
        </b-card>
        <!--
        <b-card
          title="Master Dropsmart App"
          :img-src="masterDropsmartAppImg"
          img-alt="Master Dropsmart App"
          img-top
          class="text-center"
          @click="$emit('navigate', 'LiveQAShowAllCards'); categorySelected('MasterApp');"
        >
        </b-card>
        <b-card
          title="Extra"
          :img-src="extraImg"
          img-alt="Extra"
          img-top
          class="text-center"
          @click="$emit('navigate', 'LiveQAShowAllCards'); categorySelected('Extra');"
        >
        </b-card>
        -->
      </b-card-group>
    </div>
  </div>
</template>

<script>
import liveqaShowAll from "@/assets/images/centre/liveqa/LiveQAShowAll.png";
//import masterDropsmartApp from "@/assets/images/centre/liveqa/MasterDropsmartApp.png";
import extra from "@/assets/images/centre/liveqa/Extra.png";
//import proTips from "@/assets/images/centre/liveqa/ProTips.png";


export default {
  name: "LiveQACategoriesCards",
  components: { },
  data() {
    return {
      liveqaShowAllImg: liveqaShowAll,
      extraImg: extra,
      //masterDropsmartAppImg: masterDropsmartApp,
      //proTipsImg: proTips,
    }
  },
  methods: {
    categorySelected(category) {
      this.$root.$emit(
        "liveqa-category",
        category
      );
      this.$router.push({
        name: "LiveQA",
        query: { category: category },
    }).catch(()=>{});
    },
  },
};
</script>

<style scoped lang="scss">
$light-gray: #e7e7e7;

.categories-title {
  font-weight: 700;
  margin-bottom: 3rem;
}

div.card {
  border: none;
  display: inline-block;
  transition: all .2s ease-in-out;
  &:hover {
    cursor: pointer;
    transform: scale(1.1);
  }
}

.card-img-top {
  border-radius: 50%;
  vertical-align: middle;
  background-color: $light-gray;
  width: 160px;
  height: 160px;
  filter: drop-shadow(0 0.5rem 0.25rem rgba(0, 0, 0, 0.2));
}

h4.card-title {
  font-size: 16px;
}

@media screen and (max-width: 767px) {
  div.card-deck.categories-deck {
    display: flex;

    .card {
      margin-bottom: 0;
    }

    .card-img-top {
      max-width: 100%;
      height: auto;
      padding: 0.3rem;
      background-color: transparent;

    }

    h4.card-title {
      font-size: 10px;
    }
  }
}
</style>
